import { useNavigate } from 'react-router-dom';
import { useSession } from '@/store/session';
import Ornament from '@/components/Ornament';

export default function Welcome() {
  const navigate = useNavigate();
  const { storeId, sellerId, startConsultation } = useSession();

  const onStart = () => {
    startConsultation();
    navigate('/cliente');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-12 py-10 animate-fade-in relative">
      {/* Esquinas decorativas en el viewport */}
      <CornerOrnament position="top-left" />
      <CornerOrnament position="top-right" />
      <CornerOrnament position="bottom-left" />
      <CornerOrnament position="bottom-right" />

      <div className="flex flex-col items-center max-w-2xl mx-auto">
        {/* Logo grande */}
        <img
          src="/logos/elixir-full.svg"
          alt="Elixir Dubai Perfumes"
          className="h-44 w-auto select-none mb-2"
          onError={(e) => {
            (e.currentTarget as HTMLImageElement).style.display = 'none';
          }}
        />

        <Ornament size="lg" />

        {/* Tagline en script */}
        <p className="script text-elixir-gold text-3xl md:text-4xl mb-2">
          la fragancia que te encuentra a ti
        </p>

        <h1 className="display text-4xl md:text-5xl text-elixir-cream text-center mt-4 mb-3">
          Diagnóstico Olfativo
        </h1>
        <p className="serif italic text-elixir-cream/70 text-lg text-center max-w-md mb-12">
          Una experiencia personalizada para encontrar tu perfume — menos de seis minutos.
        </p>

        <button onClick={onStart} className="btn-primary text-base px-14 py-5">
          Comenzar consulta
        </button>
      </div>

      {/* Contexto tienda/vendedor */}
      <div className="absolute bottom-6 right-8 text-[10px] tracking-[0.2em] uppercase text-elixir-cream/40">
        {storeId ? (
          <span>
            Tienda <span className="text-elixir-gold-soft">{storeId}</span>
            {sellerId && <> · <span className="text-elixir-gold-soft">{sellerId}</span></>}
          </span>
        ) : (
          <button
            className="hover:text-elixir-gold transition"
            onClick={() => navigate('/admin')}
          >
            Configurar tablet
          </button>
        )}
      </div>
    </div>
  );
}

function CornerOrnament({ position }: { position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right' }) {
  const map = {
    'top-left':     'top-6 left-6 border-t border-l',
    'top-right':    'top-6 right-6 border-t border-r',
    'bottom-left':  'bottom-6 left-6 border-b border-l',
    'bottom-right': 'bottom-6 right-6 border-b border-r',
  };
  return <span className={`absolute w-10 h-10 border-elixir-gold/35 ${map[position]} pointer-events-none`} />;
}
